'use strict';

require('../../style/index.less');

require('../../popover/style');

require('../../button/style');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/popconfirm/style/index.js
// module id = 92
// module chunks = 0